import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import IndicatorDetailsScreen, { extractVariables } from "../../screen/IndicatorDetailsScreen"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import { sort } from "fast-sort"
import { UseOdsArea } from "../../core/utils/hooks/useOdsArea"
import { useScope } from "../SelectProjectCompanyContainer"

export const loadDataIndicatorActions = async (indicatorId, projectId, scopeType) => {
  const indicator = await Send.get(`/scale-indicator/${indicatorId}`)
  const actions = await Send.get(`/recommendation-action/indicator/${indicator?.id}/project/${projectId}`, `scopeType=${scopeType}`)

  if (indicator?.updatedAt) {
    delete indicator.updatedAt
  }

  return {
    indicator: indicator || {},
    actions: actions || [],
    project: {}
  }
}

const IndicatorDetailsContainer = ({
  showOnlyActions = false,
  handleCloseActionsModal,
  showModalActions,
  esmId,
  scaleIndicatorId
}) => {
  const params = useParams()
  const navigate = useNavigate()
  const { scope, scopeType } = useScope()
  const [isUpdate, setIsUpdate] = useState(false)
  const [projects, setProjects] = useState([])
  const [actionList, setActions] = useState([])
  const [copyRows, setCopyRows] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [needReload, setNeedReload] = useState(true)
  const [values, setValues] = useState({
    projects: [],
    scale: params?.esmId,
    variables: "[]",
    category: "",
    formula: `function add(a, b) {\n  return a + b;\n}`,
    max: 100,
    min: 0,
  })

  const odsArea = UseOdsArea()?.areas?.map((item, index) => ({
    value: index,
    label: item,
  }));

  useEffect(() => {
    if (needReload && params && params?.indicatorId) {
      setIsUpdate(true)
      loadDataIndicatorActions(params.indicatorId, scope?.id, scopeType).then(({ indicator, actions }) => {
        setValues({...indicator, projects: []})
        setActions(actions)
      })
      setNeedReload(false)
    } else if (needReload) {
      setIsUpdate(false)
      setNeedReload(false)
    }
  }, [needReload])

  const onBack = () => {
    navigate(`/esm/indicators/${params?.esmId}`)
  }

  const goBack = () => {
    navigate(-1)
  }

  const onSaveIndicator = async () => {
    const response = await Send.post("/scale-indicator", {
      ...values,
      variables: JSON.stringify(extractVariables(values?.formula || ''))
    })

    if (response && response?.id) {
      customToast("Indicador salvo", "success")
      navigate(`/esm/indicator/${params?.esmId}/${response?.id}`)
      setNeedReload(true)
    } else {
      customToast("Erro ao salvar indicador", "error")
    }
  }

  const onUpdateIndicator = async () => {
    const response = await Send.put(`/scale-indicator/${values?.id}`, {
      ...values,
      variables:  JSON.stringify(extractVariables(values?.formula || ''))
    })

    if (response && response?.id) {
      customToast("Indicador atualizado", "success")
      navigate(`/esm/indicator/${params?.esmId}/${response?.id}`)
    } else {
      customToast("Erro ao atualizar indicador", "error")
    }
  }

  const removeIndicator = async () => {
    const response = await Send.delete(`/scale-indicator/${values?.id}`)

    if (response && response?.status === "success") {
      customToast("Indicador Removido", "success")
      onBack()
    } else {
      customToast("Erro ao remover indicador", "error")
    }
  }

  const onSaveActions = async (data = [], setOpen, setShowModalActions) => {

    data = data
      .filter((item) => item?.title)
      .map((item) => ({
        title: item?.title,
        description: item?.description,
        indicatorId: params?.indicatorId || scaleIndicatorId,
        projectId: values?.projects || scope?.id,
      }))


    const response = await Send.post("/recommendation-action", data)

    if (response && response?.status === "success") {
      customToast("Ações adicionadas", "success")
      setNeedReload(true)
      handleCloseActionsModal ? setShowModalActions() : setOpen(false);
      setValues({ actions: [] })
      return
    } else {
      customToast("Erro ao adicionar ações", "error")
      setNeedReload(true)
      setValues({ actions: [] })
      handleCloseActionsModal ? setShowModalActions() : setOpen(false);
    }


    /* if (isEmptyValue) {
      customToast("Selecione uma area e um nível ", "info");
      return
    } */

    /* data = data
      .filter((item) => item?.title)
      .map((item) => ({
        ...item,
        indicator: params?.indicatorId || scaleIndicatorId,
        project: params?.esmId || esmId,
      }))

    const response = await Send.post("/recommendation-action", data)

    if (response && response?.status === "success") {
      customToast("Ações adicionadas", "success")
      setNeedReload(true)
      handleCloseActionsModal ? setShowModalActions() : setOpen(false);
      setValues({ actions: [] })
      return
    } else {
      customToast("Erro ao adicionar ações", "error")
      setNeedReload(true)
      setValues({ actions: [] })
      handleCloseActionsModal ? setShowModalActions() : setOpen(false);
    } */
  }

  const loadESMProjects = async () => {
    try {
      const response = await Send.get(`/scale-project/scale/${params?.esmId}`)

      if (response?.length > 0) {
        setProjects(response.map(({ id, description }) => ({ value: id, label: description })))
      }
    } catch (error) {
      console.log("error", error)
      customToast("Erro ao buscar projetos", "error")
    }
  }

  useEffect(() => {
    loadESMProjects()
  }, [params])

  useEffect(() => {
    if (copyRows.length > 0) {
      const temp = actionList.filter((obj1) => !copyRows.some((obj2) => obj1.id === obj2.id))
      const arr1 = [...temp, ...copyRows]
      setActions(sort(arr1).desc((u) => u?.title))

      onUpdateAction(copyRows[0])
    }
  }, [copyRows])

  const handleReloadActions = () => {
    setNeedReload(true);
  }

  const onSelectedRowsChange = (dataId) => {
    setSelectedRows(dataId)
  }

  const onUpdateAction = async (data) => {
    try {
      delete data.indicator
      delete data.updatedAt
      delete data.deletedAt
      delete data.createdAt
      delete data.edit

      const id = data.id

      delete data.id
      await Send.put(`/recommendation-action/${id}`, data)
      customToast("Recomendação alterada com sucesso", "success")
      setNeedReload(true)
    } catch (error) {
      customToast("Erro ao alterar a recomendação", "error")
    }
  }

  const removeAction = async (id) => {
    try {
      await Send.delete(`/recommendation-action/${id}`)
      customToast("Recomendação deletada com sucesso", "success")
      setNeedReload(true)
    } catch (error) {
      customToast("Erro ao deletar Recomendação", "error")
    }
  }

  const handleChangeProject = (value) => {
    if (value && value?.length > 0) {
      setValues((prev) => ({ ...prev, projects: value }))
    } else {
      setValues((prev) => ({ ...prev, projects: [] }))
    }
  }

  return (
    <IndicatorDetailsScreen
      {...{
        isUpdate,
        setValues,
        values,
        actionList,
        onSaveIndicator,
        onUpdateIndicator,
        removeIndicator,
        onBack,
        onSaveActions,
        setCopyRows,
        onSelectedRowsChange,
        removeAction,
        selectedRows,
        showOnlyActions,
        showModalActions,
        odsArea,
        goBack,
        handleReloadActions,
        projects,
        handleChangeProject 
      }}
    />
  )
}

export default IndicatorDetailsContainer